/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayOSSContainerProxy
 * @typechecks
 * 
 */

/**
 * This feature is deprecated and unavailable in open source.
 */
'use strict';

var RelayOSSContainerProxy = {
  proxyMethods: function proxyMethods(RelayContainer, Component) {}
};

module.exports = RelayOSSContainerProxy;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/lib/RelayOSSContainerProxy.js
 ** module id = 539
 ** module chunks = 0
 **/